import React, { useState } from "react";
import moment from "moment";
import TableWrapper from "../common/TableWrapper";
import { Link } from "react-router-dom";
import Button from "../common/Button";
import styles from "./TableStyles.module.scss";
import downloadIcon from "../../static/images/download-icon.svg";
import { downloadInvoices, downloadPDFs, newFiscalPdfDownload, newFiscalJPGDownload } from "../utils";
import MultiInvoiceModal from "../modals/MultiInvoiceModal";

function RidesTable({ data, loading, onPaginationChange, pagination, hidePagination = false }) {
  const activePage = data?.current_page;
  const totalElements = data?.total;
  const pageSize = pagination?.size || data?.per_page;

  const [multiInvoiceList, setMultiInvoiceList] = useState(null);

  const columns = [
    {
      header: "Service",
      render: (e) => (
        <>
          <b>{e.id}</b>
          <div>{moment(e.finished_at).format("DD/MM/YYYY HH:mm")}</div>
          {!!e.contact && <div className={styles.contact}>• For someone else</div>}
        </>
      ),
      options: {
        width: 150,
      },
    },
    {
      header: "User",
      render: (e) => (
        <>
          <Link to={`/users/${e.user_id}`}>{e?.user?.firstName + " " + e?.user?.lastName}</Link>
        </>
      ),
      options: {
        width: 200,
      },
    },
    {
      header: "From",
      dataKey: "location",
      options: {
        width: 200,
      },
    },
    {
      header: "To",
      dataKey: "final_destination_address",
      options: {
        width: 200,
      },
    },
    { header: "Distance", render: (e) => `${(e.distance / 1000).toFixed(3)} km` },
    { header: "Ride Time", render: (e) => `${e?.minutes || 0} min` },
    {
      header: "Total Price",
      render: (e) => (
        <span>
          <div>
            {(
              e.platform_fee +
              e.platform_fee_with_vat +
              e.price +
              e.price_with_vat +
              Number.parseFloat(e.priority_fee) +
              Number.parseFloat(e.priority_fee_with_vat) +
              e.tip_captured
            )?.toFixed(2)}{" "}
            RSD
          </div>
          {!!e.priority && (
            <div className={styles.priority}>
              • Priority {(e.priority_fee + e.priority_fee_with_vat)?.toFixed(2)} RSD
            </div>
          )}
        </span>
      ),
      options: {
        width: 150,
      },
    },
    { header: "Platform Fee", render: (e) => (e.platform_fee + e.platform_fee_with_vat)?.toFixed(2) + " RSD" },
    { header: "Tip", dataKey: "tip_sent", render: (e) => e.tip_sent?.toFixed(2) + " RSD" },
    {
      header: "Ordered for someone else",
      render: (e) => (
        <div>
          {e?.contact && (
            <>
              {e?.contact?.name}
              <br />
              {e?.contact?.phone}
            </>
          )}
        </div>
      ),
      options: {
        width: 250,
      },
    },
    {
      header: "Fiscal invoice download",
      render: (e) => (
        <>
          {e?.invoice?.length > 0 && (
            <div className={styles.downloadButtonsWrap}>
              <Button
                onClick={() => downloadInvoices(e?.invoice)}
                className={styles.downloadInvoiceButton}
                variant="white">
                <img height={16} src={downloadIcon} alt="download icon" />
                jpg
              </Button>
              <Button onClick={() => downloadPDFs(e?.invoice)} className={styles.downloadInvoiceButton} variant="white">
                <img height={16} src={downloadIcon} alt="download icon" />
                pdf
              </Button>
            </div>
          )}
          {e?.fiscal_invoice?.length > 1 && (
            <div className={styles.downloadButtonsWrap}>
              <Button
                onClick={() => setMultiInvoiceList(e?.fiscal_invoice)}
                className={styles.downloadInvoiceButton}
                variant="white">
                Download invoices ({e?.fiscal_invoice?.length})
              </Button>
            </div>
          )}
          {e?.fiscal_invoice?.length === 1 && (
            <div className={styles.downloadButtonsWrap}>
              <Button
                onClick={() => {
                  newFiscalJPGDownload(e?.fiscal_invoice);
                }}
                className={styles.downloadInvoiceButton}
                variant="white">
                <img height={16} src={downloadIcon} alt="download icon" />
                jpg
              </Button>
              <Button
                onClick={() => {
                  newFiscalPdfDownload(e?.fiscal_invoice);
                }}
                className={styles.downloadInvoiceButton}
                variant="white">
                <img height={16} src={downloadIcon} alt="download icon" />
                pdf
              </Button>
            </div>
          )}
        </>
      ),
      options: {
        width: 200,
        fixed: "right",
      },
    },
  ];

  return (
    <>
      <MultiInvoiceModal close={() => setMultiInvoiceList(null)} invoiceList={multiInvoiceList} />
      <TableWrapper
        loading={loading}
        totalElements={totalElements}
        pageSize={pageSize}
        activePage={activePage}
        columns={columns}
        emptyMessage="No services yet"
        onChange={onPaginationChange}
        data={data?.data || []}
        hidePagination={hidePagination}
      />
    </>
  );
}

export default RidesTable;
